import React from 'react';
// import './App.css';
import { Overview } from './routes/overview';
import 'styles/global.scss';
import { Provider } from 'react-redux';
import { store } from 'core/redux/store';

const App: React.FC = () => {
  React.useEffect(() => { }, []);

  return (
    <Provider store={store}>
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
      <Overview />
    </Provider>
  );
};

export default App;
